initSvgIcon();

export function initSvgIcon() {
    $('svg[data-icon]').each(function (i, el) {
        var iconUrl = iconBase+$(this).data('icon');
        $(this).addClass('icon');
        $(this).removeAttr('data-icon');
        $(this).html('<use xlink:href="'+iconUrl+'"></use>')
    });
}